"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
exports.FilterDesktopSelected = function (props) {
    return (React.createElement("div", { className: "hidden md:block" }, props.selectedFilters.map(function (selectedFilter) { return (React.createElement("div", { className: "mt-1-8" },
        React.createElement("div", null,
            React.createElement("button", { className: "flex items-center py-1 text-xs rounded cursor-pointer bg-secondary-blue-grey text-midnight px-0-8 mr-0-8 mb-0-8 focus:outline-none ie-cloud-item", onClick: function () { return props.handleRemove(selectedFilter.key); } },
                React.createElement("p", { className: "mr-1-2" }, "Clear " + selectedFilter.label + " Filters"),
                React.createElement("div", { className: "block" },
                    React.createElement(Snippets.Svg, { name: "cross", width: 8 })))),
        React.createElement("div", { key: selectedFilter.key, className: "flex-wrap items-start justify-start hidden md:flex" }, selectedFilter.value && selectedFilter.value.length > 0
            ? selectedFilter.value.map(function (value, vIndex) {
                return (React.createElement("div", { key: vIndex, className: "flex items-center py-1 text-xs rounded cursor-default bg-secondary-blue-grey text-midnight px-0-8 mr-0-8 mb-0-8 focus:outline-none ie-cloud-item" },
                    React.createElement("p", { className: "mr-1-2" }, "" + value)));
            })
            : null))); })));
};
